import { useApiClient } from 'helpers/api/apiCoreNewClient';

export interface NParcel {
    btParcelId: string;
    shipmentBTId: string;
    length: number;
    width: number;
    height: number;
    distanceUnit: string | null;
    weight: number;
    massUnit: string;
    metadata: string;
    objectId: string;
    objectCreated: string;
    objectUpdated: string;
    arrivalLocation: string | null;
}

export interface NShipments {
    btShipmentId: string;
    objectId: string;
    addressFrom: string | null;
    addressTo: string | null;
    addressReturn: string | null;
    nParcels: NParcel[];
    isSignatureRequired: boolean;
    isOver18Required: boolean;
    isOver21Required: boolean;
    isPerishable: boolean;
    metadata: string;
    objectCreated: string;
    objectUpdated: string;
    shipmentState: string | null;
    objectOwner: string | null;
    nShipmentRates: [];
}

export interface ContainerLabelDTO {
    id: number;
    btContainerId: string;
    labelUrl: string | null;
    objectId: string;
    licensePlate: string | null;
    parcels: NParcel[];
    containers: ContainerLabelDTO[];
    metadata: string;
    metroConfigurationName: string | null;
    containerType: ContainerType;

    metroCode: {
        id: number;
        code: string;
    };
    objectCreated: string;
    objectUpdated: string;

    hubMetroMappings: HubMetroMapping[];
    companies: Company[];
    multiCompanyContainerConfig:{
        id: number;
        name: string;
    };
    shiftContainerAssociations: ShiftContainerAssociation[];
}

export interface ShiftContainerAssociation{
    id: number;
    name: string | null;
    licensePlate: string | null;
}

export interface HubMetroMapping {
    id: number;
    name: string;
    metroCodes: string[];
}

export interface Company {
    id: number;
    name: string;
    isEnableNewBtId: boolean;
    isRelayEdiUpdates: boolean;
}

export interface ContainerLabel {
    metroCode?: string;
    licensePlate: string;
    isMasterContainer: boolean;
    metadata?: string;
    numberOfContainers: string;
}

export enum ContainerType {
    MetroCode = 'MetroCode',
    Company = 'Company',
    LineHaul = 'LineHaul',
    ZoneSubZone = 'ZoneSubZone',
    Route = 'Route'
}

export type ContainerFormInputs = {
    filterBy: string | null;
    search: string | null;

    dateRangeFrom: string | number | Date;
    dateRangeTo: string | number | Date;

    metroCodeIds: string[] | null;

    route: string | null;
    containerType: string | null;
};

export const useContainerService = () => {
    const client = useApiClient()
    
    return {
    getContainerLabels: (data: ContainerFormInputs) => {
        return client.get<ContainerLabelDTO[]>(`api/Containers`);
    },

    addContainerLabel: (data: ContainerLabel) => {
        return client.post(`api/Containers`, data);
    },

    getContainerByBtContainerId: (btContainerId: string, isPagination: boolean, pageNumber: number, perPage: number) => {
        return client.get<ContainerLabelDTO>(`api/Containers/${btContainerId}?isPagination=${isPagination}&pageNumber=${pageNumber}&perPage=${perPage}`);
    },

    getContainerParcelById: (btContainerId: string, btParcelId: string) => {
        return client.get<NParcel>(`api/Containers/${btContainerId}/Parcel/${btParcelId}`);
    },
}
}
